export default __webpack_public_path__ + "static/joko-app-screenshot-home-4-fr-cf99796fca86c38e6eaa35ad12026ac1.png";